// Analytics
(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
    })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
    
    ga('create', 'UA-9264035-1', 'auto');
    
    ga('require', 'displayfeatures');

    // Analytics para os autores da notícia
    let dimension = "dimension";
    if (typeof(AUTORES_NOTICIA) != 'undefined' && (AUTORES_NOTICIA.length != 0)) {
        for(i=0;i<AUTORES_NOTICIA.length;i++){
            ga('set', dimension+(i+1), AUTORES_NOTICIA[i]);
        }
    };
    ga('send', 'pageview');
    
    // ga('create', 'UA-81883435-1', {'cookieName': 'centralizador','name': 'datudo'});
    // ga('datudo.send', 'pageview');
    
    function reloadanalytics(){
        ga('send', 'pageview');
    };
    
    function reloadAnalyticsGallery(urlFotos) {
        ga('send', urlFotos);
    };
    
    function eventoGA(cat, acao, marc) {
        ga('send', 'event', {eventCategory: cat, eventAction: acao, eventLabel: marc});
    };
    
    function eventoGAsocial(cat, acao, marc){
        ga('send', 'social', {socialNetwork: cat, socialAction: acao, socialTarget: marc})
    } 